// DEMO / LANIS 2.0 config — a separate app instance that talks to the new
// Railway backend (isolated from the live/real account, which stays on
// golanis via production.js). Selected by building with
// REACT_APP_ENV_TARGET=demo. Used for the sales demo platform and 2.0 testing.
const config = {
  serviceHost: "https://lanis-tierone-tier-one-api-production.up.railway.app/",
  creditHost: "https://divine-creation-production-2aa4.up.railway.app/",
  stripePublicApiKey: "pk_live_EQD9DT3DjcNw01hhE6Sf0fzF00BGBPM14u",
  // VIEW/VISION dashboard is a demo-backend feature (needs the new backend's
  // /admin/dashboard-data). Production (golanis) leaves this off so real
  // subscribers never see the Dashboard button or hit the missing endpoint.
  enableDashboard: true,
  // "What is your Submit-to-Close ratio?" what-if simulator on the dashboard.
  // DEMO ONLY: no other config sets this, so Production never shows it.
  enableDemoSimulator: true
};

export default config;
